import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * The sending-domain block (`GET /api/automation/sending-domain`): the default Solunary
 * subdomain (always available) and, once connected, the practice's own domain with its
 * SPF/DKIM records and verification status. Every send uses `active_from` — the
 * subdomain until the custom domain is `verified` (spec: "nothing ever bounced during
 * setup").
 */
export default function useSendingDomain() {
  const [domain, setDomain] = useState(null);
  const load = useCallback(async () => { setDomain(await crmApi.getSendingDomain()); }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const connect = useCallback(async (payload) => {
    const saved = await crmApi.connectSendingDomain(payload);
    setDomain(saved);
    return saved;
  }, []);

  const verify = useCallback(async () => {
    const saved = await crmApi.verifySendingDomain();
    setDomain(saved);
    return saved;
  }, []);

  const disconnect = useCallback(async () => {
    const saved = await crmApi.disconnectSendingDomain();
    setDomain(saved);
    return saved;
  }, []);

  return { domain, loading, loadError, reload, connect, verify, disconnect };
}
